/**
 * Encrypt incident JSON with the same primitive as platf_view-feeds (encryptPost).
 * Dynamic import so the feeds key/salt stay the single source of truth.
 */

async function loadFeedCrypto() {
  try {
    const mod = await import('@trazit/platf_view-feeds/src/utils/feed-encryption.js');
    return mod;
  } catch (_) { /* try repo sibling */ }
  const mod = await import('../../../master-components/platf_view-feeds/src/utils/feed-encryption.js');
  return mod;
}

export async function encryptFeedsCompatibleJson(data) {
  const mod = await loadFeedCrypto();
  const encryptPost = mod.encryptPost;
  if (typeof encryptPost !== 'function') {
    throw new Error('incident-context: encryptPost not exported by feed-encryption.js');
  }
  return encryptPost(data);
}

export async function decryptFeedsCompatibleJson(encryptedText) {
  const mod = await loadFeedCrypto();
  const decryptPost = mod.decryptPost;
  if (typeof decryptPost !== 'function') {
    throw new Error('incident-context: decryptPost not exported by feed-encryption.js');
  }
  return decryptPost(encryptedText);
}
